<template>
    <el-container style="height: 100%;background: rgb(239,239,239);" :class="$route.params.title == '阵列位移计'?'demo':''">
      <Sidebar></Sidebar>
      <Header></Header>
    </el-container>
</template>

<script>
import IconFont from '@/assets/icon/iconfont.css'
import Header from './Layout/Header'
import Sidebar from './Layout/Sidebar/Sidebar'
export default {
  name : 'Layout',
  components: {
    Header,
    Sidebar
  }
}
</script>

<style scoped>
  >>> .iconfont{
    margin-right: 8px !important;
  }
  .demo{
   padding-bottom:45px
  }
</style>




// WEBPACK FOOTER //
// src/components/Layout.vue